import _ from '../utils'

const FORM_FILES_CONFIG = {
    els: _.selectAll( '.c-form__input--file-multiple' )
}

export default FORM_FILES_CONFIG